/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, {AxiosRequestConfig} from 'axios';
import {Glum} from 'puddleglum';
import {transformToQueryString, PaginatedResponse} from 'puddleglum/utils';

export default class EmployerOnboardingController {
	static async getStatus(
		validationOnly: boolean = false,
		fieldToValidate: string = '',
		config: AxiosRequestConfig = {},
	) {
		return axios.get<{
			is_stripe_connected: boolean;
			are_employees_added: boolean;
			is_profile_completed: boolean;
			is_deposit_paid: boolean;
			deposit_amount: number;
		}>(`/api/employer/onboarding`, {
			headers: {
				Precognition: validationOnly,
				...(fieldToValidate ? {'Precognition-Validate-Only': fieldToValidate} : {}),
			},
			...config,
		});
	}
}
